import locationsStep from './locations_step'
import elementsStep from './elements_step'
import summaryStep from './summary_step'
import { types } from '../../actions/campaigns/common_actions'
import { types as elementsSelectorTypes } from '../../actions/campaigns/elements_selector_actions'
import defaultState from '../../store/default_state'
import CampaignElementItem from '../../models/campaigns/element'

function locationsByTags(locations, tagsById, tagIds) {
  return locations.map((item) => {
    const itemTags = tagIds.reduce((result, tagId) => {
      if (item.tagIDs?.includes(tagId)) {
        result.push(tagsById[tagId])
      }
      return result
    }, [])

    if (itemTags.length > 0) {
      return { ...item, matchedTags: itemTags, selected: true }
    } else if (item.matchedTags && item.matchedTags.length > 0) {
      return { ...item, matchedTags: [], selected: false }
    }
    return item
  })
}

const elementsByTags = (elements, tagsById, tagIds) => {
  return elements.map((item) => {
    const itemTags = tagIds.reduce((result, tagId) => {
      if (item.tagIDs.includes(tagId)) {
        result.push(tagsById[tagId])
      }
      return result
    }, [])

    if (itemTags.length > 0) {
      const newItem = CampaignElementItem.reInitCopy(item)
      newItem.update({ matchedTags: itemTags, selected: true })
      return newItem
    } else if (item.matchedTags && item.matchedTags.length > 0) {
      const newItem = CampaignElementItem.reInitCopy(item)
      newItem.update({ matchedTags: [], selected: false })
      return newItem
    }
    return item
  })
}

function selectItemsByTags(state, tags, itemType) {
  const tagsById = tags.reduce((result, tag) => {
    result[tag.value] = tag
    return result
  }, {})
  const tagIds = tags.map((t) => t.value || t.id)
  const updatedTags = state.tags.map((tag) => ({
    ...tag,
    selected: tagIds.includes(tag.value),
  }))
  const itemTypeFunction = itemType == 'elements' ? elementsByTags : locationsByTags

  return {
    ...state,
    [itemType]: itemTypeFunction(state[itemType], tagsById, tagIds),
    tags: updatedTags,
  }
}

function removeItemWithTags(state, item) {
  // Get tag IDs from the removed item's matched tags
  const tagIdsToRemove = item.matchedTags.map((tag) => tag.value || tag.id)

  // Update tags to mark them as not selected
  const updatedTags = state.tags.map((tag) => {
    if (tagIdsToRemove.includes(tag.value)) {
      return { ...tag, selected: false }
    }
    return tag
  })

  // Update all elements to remove those tags from their matchedTags
  const updatedElements = state.elements.map((el) => {
    if (el.cID.isEqual(item.cID)) {
      // This is the item being removed, skip it (already handled by elements_step reducer)
      return el
    }

    if (el.matchedTags && el.matchedTags.length > 0) {
      // Filter out the tags being removed
      const newMatchedTags = el.matchedTags.filter(
        (tag) => !tagIdsToRemove.includes(tag.value || tag.id)
      )

      // If matchedTags changed, update the element
      if (newMatchedTags.length !== el.matchedTags.length) {
        const newEl = CampaignElementItem.reInitCopy(el)
        newEl.update({ matchedTags: newMatchedTags })
        return newEl
      }
    }

    return el
  })

  return {
    ...state,
    elements: updatedElements,
    tags: updatedTags,
  }
}

export default function reducer(state = defaultState.campaigns, action) {
  // Run sub-reducers in sequence
  state = locationsStep(state, action)
  state = elementsStep(state, action)
  state = summaryStep(state, action)

  switch (action.type) {
    case types.SELECT_BY_TAGS:
      return selectItemsByTags(state, action.tags, action.itemType)
    case elementsSelectorTypes.REMOVE_ITEM_WITH_TAGS:
      return removeItemWithTags(state, action.item)
    default:
      return state
  }
}
